// Google Analytics
export const GOOGLE_ANALYTICS_ID = 'UA-32120185-31'

// request status
export const STATUS_IS_LOADING = 1
export const STATUS_SUCCESS = 2
export const STATUS_FAILED = 3

// session items
export const SESSION_HEADERS = concatEnv('99_EMPRESAS_SESSION')
export const SESSION_USER = concatEnv('99_EMPRESAS_USER')
export const SESSION_COMPANY = concatEnv('99_EMPRESAS_COMPANY')
export const SESSION_ALLOWED_GEOLOCATION = concatEnv('99_EMPRESAS_GEOLOCATION')
export const WELCOME_DIALOG_VISIBILITY = concatEnv('99_WELCOME_DIALOG_VISIBILITY')
export const SESSION_WELCOME = concatEnv('99_EMPRESAS_WELCOME')
export const COST_CENTER_COUNTER = concatEnv('99_EMPRESAS_COST_CENTER_COUNTER')
export const SESSION_SKIP_WIZARD = concatEnv('99_EMPRESAS_SKIP_WIZARD')

// location
export const SESSION_LOCALE = concatEnv('99_EMPRESAS_LOCALE')

// seconds * minutes * hours
export const SESSION_EXPIRES_TIME = concatEnv('99_EMPRESAS_SESSION_EXPIRES_TIME')
export const SESSION_TIME = 60 * 60 * 24 // 86400 / 24h
export const SESSION_EXPIRES_TIME_VALUE = 30
export const SESSION_EXPIRES_TIME_UNIT = 'minutes'
export const SESSION_EXPIRES_WARNING_VALUE = 5
export const SESSION_EXPIRES_WARNING_UNIT = 'minutes'

// path to redirect to page on login
export const REDIRECT_PATH_ON_AUTH = concatEnv('99_EMPRESAS_REDIRECT_PATH_ON_AUTH')

// table pagination
export const TABLE_PAGINATION_LIMIT = 25

function concatEnv (str) {
  const env = process.env.NODE_ENV.toUpperCase()
  const isProduction = env === 'production'
  return !isProduction ? `${str}_${env}` : str
}
